import React, { Fragment, useEffect, useState } from 'react';

import { Layout } from 'antd';
import { jwtDecode } from 'jwt-decode';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import SidebarComponent from './sidebar';
import HeaderComponent from './header';
import ContenetComponent from './content';
import Designation from '../pages/designation/Designation';

import { privateRoutes } from '../navigations/navigations';

import { setLoginUserId, setLoginUserPackage, setLoginUserRole } from '../pages/user/redux/slice';
import { getDecodeToken, onOrganizerBoardring, setIsAuthorize } from '../pages/auth/redux/slice';
import { getLanguage, setMenuPermission } from '../redux/slice/global';
import { getUserTypeMenuListing } from '../pages/user-type/redux/slice';

const Wrapper = ({ children }) => {
    const dispatch = useDispatch()
    const auth = useSelector(state => state.auth);
    const [collapsed, setCollapsed] = useState(false);
    const [loginUser, setLoginUser] = useState({});
    const [filteredRoutes, setFilteredRoutes] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (token) {
            const user = jwtDecode(token);
            if (user._id && auth.isAuthorize !== '') {
                user.organizer && dispatch(onOrganizerBoardring(user._id))
            }

            dispatch(getDecodeToken(user))
            setLoginUser(user);
            dispatch(setIsAuthorize(user.isInitialSignIn))
            dispatch(setLoginUserId(user._id))
            dispatch(setLoginUserRole(user.role))
            dispatch(setLoginUserPackage(user.package));
            dispatch(getLanguage(user._id));
            if (user?.organizer && user?.package) {
                dispatch(getUserTypeMenuListing(user?.package))
            } else if (user?.organizer) {
                dispatch(getUserTypeMenuListing())
            }
        }
    }, [])

    useEffect(() => {
        if (loginUser) {
            const token = localStorage.getItem("token");
            const user = jwtDecode(token);

            if (user._id && auth.isAuthorize !== '') {
                user?.organizer && dispatch(onOrganizerBoardring(user._id));
            }

            const filterRoutesByPermission = (routes, permissions) => {
                // Iterate permissions (not routes) to preserve the saved menu order
                return permissions
                    .map(permission => {
                        if (!permission?.permissions?.hasAccess) return null;
                        const route = routes.find(r => r?.label && r.menu === permission.menu);
                        if (!route) return null;

                        if (route.children && route.children.length > 0) {
                            const filteredChildren = route.children.filter(child =>
                                permission.children &&
                                permission.children.some(permissionChild =>
                                    permissionChild.menu === child.menu && child.label && permissionChild?.permissions?.hasAccess
                                )
                            );
                            return { ...route, children: filteredChildren };
                        }
                        return route;
                    })
                    .filter(route => route !== null);
            };

            const PLATFORM_ADMIN_MENUS = ['Dashboard', 'Client', 'Packages', 'User Mgnt.'];
            const isPlatformAdmin = !user?.organizer;
            const filteredRoutes = isPlatformAdmin
                ? privateRoutes.filter(r => PLATFORM_ADMIN_MENUS.includes(r.menu))
                : filterRoutesByPermission(privateRoutes, user?.permissions[0]?.menu);

            if (user?.organizer && auth?.isAuthorize) {
                setFilteredRoutes(filteredRoutes?.map((item) => {
                    if (item.label === 'Settings') {
                        const x = item.children.map((children) => {
                            if (children.label.props.children === 'General Setting') {
                                return children
                            }
                            else {
                                return {
                                    ...children,
                                    disabled: auth?.isAuthorize,
                                    label: auth?.isAuthorize ? children.label?.props?.children ? children.label?.props?.children : children.label : children.label
                                }
                            }
                        })
                        return {
                            ...item,
                            children: x
                        };
                    }
                    else {
                        return {
                            ...item,
                            disabled: auth?.isAuthorize,
                            label: auth?.isAuthorize ? item.label?.props?.children ? item.label?.props?.children : item.label : item.label
                        }
                    }
                })?.map(i => {
                    const { children, ...route } = i
                    const visibleChildren = children?.filter(c => c.label)
                    return {
                        ...route,
                        ...(visibleChildren?.length > 0) && { children: visibleChildren }
                    }
                })
                );
            } else {
                setFilteredRoutes(filteredRoutes?.filter(i => i.label)?.map(i => {
                    const { children, ...route } = i
                    const visibleChildren = children?.filter(c => c.label)
                    return {
                        ...route,
                        ...(visibleChildren?.length > 0) && { children: visibleChildren }
                    }
                })
                );
            }
        }

    }, [loginUser, auth?.isAuthorize]);

    return (
        <Fragment>
            <Layout className='vh-100 flex gap-1 padding-2'>
                <SidebarComponent collapsed={collapsed} setCollapsed={setCollapsed} filteredRoutes={filteredRoutes} />
                <Layout>
                    <HeaderComponent collapsed={collapsed} setCollapsed={setCollapsed} />
                    <ContenetComponent children={children} />
                </Layout>
            </Layout>
        </Fragment>
    )
}

export default Wrapper;
